const BitcoinIcon = ({ className = "", size = 64 }: { className?: string; size?: number }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="30" fill="url(#btcGrad)" stroke="url(#btcStroke)" strokeWidth="2" />
    <text
      x="32"
      y="42"
      textAnchor="middle"
      fontFamily="Orbitron, sans-serif"
      fontWeight="700"
      fontSize="28"
      fill="#1a1a2e"
    >
      ₿
    </text>
    <defs>
      <linearGradient id="btcGrad" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="50%" stopColor="#FFC125" />
        <stop offset="100%" stopColor="#DAA520" />
      </linearGradient>
      <linearGradient id="btcStroke" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0%" stopColor="#FFE44D" />
        <stop offset="100%" stopColor="#B8860B" />
      </linearGradient>
    </defs>
  </svg>
);

export default BitcoinIcon;
